import * as Sentry from '@sentry/browser';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getAuth } from 'src/redux/slices/auth';

import { Logo } from '../auth/Styles';
import { StyledErrorScreen } from './Styles';

const ErrorScreen = ({error }: {error: any}) => {
  const { t } = useTranslation();
  const [errorId, setErrorId] = React.useState('');
  const auth = useSelector(getAuth);

  useEffect(() => {
    if (error && !errorId) {
      const newErrorId = Sentry.withScope(() => {
        Sentry.setUser({
          id: auth.currentUser?.id,
          username: auth.currentUser?.username,
        });
        Sentry.setExtra('accountId', auth.currentAccount?.id);
        Sentry.setExtra('userId', auth.currentUser?.id);
        
        return Sentry.captureException(error);
      })
      setErrorId(newErrorId);
    }
  }, [auth.currentAccount?.id, auth.currentUser?.id, auth.currentUser?.username, error, errorId]);

  return (
    <StyledErrorScreen>
      <Logo src="/images/biglogo.svg" />
      <h3>{ t('notifications:error') + ' Id: ' + errorId }</h3>
    </StyledErrorScreen>
  );
};

export default ErrorScreen;
